import { AnalyticsSalesComponent } from './analytics-sales.component';

export default AnalyticsSalesComponent;
